export { w as wrap } from '../common/wrap-14f018b7.js';
